module.exports = __webpack_public_path__ + "media/emojis/smiley-9566eb78.svg";